export const addItem = <T>(source: Array<T>, item: T) => {
  return [...source, item];
};

export const removeItem = <T>(source: Array<T>, target: T) => {
  return source.filter(item => item !== target);
};

export const hasIntersection = (arr1: string[], arr2: string[]): boolean => {
  const arr1Set = new Set(arr1);
  return arr2.some(val => arr1Set.has(val));
};

export type HasFavoriteProperty = { isFavorite?: boolean | null };
export const sortByFavorite = <T extends HasFavoriteProperty>(list: T[]): T[] => {
  const isFavorite = list?.find(item => item.isFavorite);

  if (isFavorite) {
    const filtered = list?.filter(item => !item.isFavorite);
    return [{ ...isFavorite }, ...filtered];
  }
  return list;
};

export type HasIdProperty = { id?: string };
export const sortByOrderList = <T extends HasIdProperty>(list: T[], orderList?: string[]): T[] => {
  let orderedList: typeof list = [];
  const listItemMap = new Map(list.map(item => [item.id, item]));
  if (orderList && orderList.length > 0) {
    orderList.forEach(orderId => {
      if (listItemMap.has(orderId)) {
        orderedList.push(listItemMap.get(orderId)!);
        listItemMap.delete(orderId);
      }
    });
    listItemMap.forEach(item => orderedList.push(item));
  } else {
    orderedList = [...list];
  }
  return orderedList?.filter(orderedListItem => orderedListItem !== undefined);
};

export type HasSortOrderProperty = { sortOrder: number };
export const sortBySortOrder = <T extends HasSortOrderProperty>(items: T[]): T[] => {
  return items.slice().sort((a, b) => a.sortOrder - b.sortOrder);
};

// checkes if arrays have the same values regardless of orders
export const arraysEqual = (arr1: string[], arr2: string[]): boolean => {
  // Create sets from both arrays to remove duplicates
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);

  // Check if both sets have the same size
  if (set1.size !== set2.size) return false;

  let areEqual = true;
  set1.forEach(item => {
    if (!set2.has(item)) {
      areEqual = false;
    }
  });

  return areEqual;
};
